import { Routes } from '@angular/router';
import { PageShellComponent } from '@features/page-shell/page-shell.component';

export const routes: Routes = [
  { path: '', component: PageShellComponent },
  { path: '**', redirectTo: '' },
];
